<template>
  <div>
    <v-card
      class="mx-auto mb-5"
      max-width="344"
      @click="goToRoute('corrigidas')"
    >
      <v-img
        src="../../assets/redacao_corrigida.svg"
        height="170px"
      ></v-img>

      <v-card-title>
        Redações Corrigidas
      </v-card-title>

      <v-card-subtitle>
        Corrigidas
      </v-card-subtitle>
    </v-card>

    <v-card
      class="mx-auto mb-5"
      max-width="344"
      @click="goToRoute('rascunho')"
    >
      <v-img
        src="../../assets/redacao_rascunho.svg"
        height="170px"
      ></v-img>

      <v-card-title>
        Redações em Rascunho
      </v-card-title>

      <v-card-subtitle>
        Rascunho
      </v-card-subtitle>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="344"
      @click="goToRoute('pendentes')"
    >
      <v-img
        src="../../assets/redacao_pendente.svg"
        height="170px"
      ></v-img>

      <v-card-title>
        Redações Pendentes
      </v-card-title>

      <v-card-subtitle>
        Pendentes
      </v-card-subtitle>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Essay',
  methods: {
    goToRoute (path) {
      this.$router.push(path)
    }
  }
}
</script>
